
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/getting-started/welcome",
      function () {
        return require("private-next-pages/getting-started/welcome.mdx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/getting-started/welcome"])
      });
    }
  